import React, { memo } from 'react';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import {
  AdjustableComponent,
  useClasses,
} from '../../../../../utils/hooks/useClasses';

export type CustomTooltipProps = {
  data: any;
  dataIdentifier: string;
  renderTooltipContent: (data: any) => any;
} & TooltipProps<ValueType, NameType>;

export type CustomTooltipStyles = {
  root: string;
};

const CustomTooltip: AdjustableComponent<
  CustomTooltipProps,
  CustomTooltipStyles
> = ({
  data,
  dataIdentifier,
  active,
  payload,
  renderTooltipContent,
  classes,
}) => {
  const styles: CustomTooltipStyles = useClasses(
    {
      root: 'CustomMonitorTooltip',
    },
    classes,
  );
  return (
    <>
      {data.map((el: any, idx: number) => {
        if (
          active &&
          payload &&
          payload[0]?.payload?.[dataIdentifier] === el[dataIdentifier]
        ) {
          return (
            <div key={`${idx}-${el[dataIdentifier]}`} className={styles.root}>
              {renderTooltipContent(el)}
            </div>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export default memo(CustomTooltip);
